import { supabase } from '../lib/supabase';
import { toast } from 'sonner';
import { assertCaseReadyForDentistSubmission } from '../lib/dentistCaseSubmissionValidation';
import notificationService from './notificationService';

/**
 * Resolves group-1 / phase_order-1 (soumission) for a case.
 */
export async function getSubmissionPhaseId(caseId) {
  const { data, error } = await supabase
    .from('case_timeline_phases')
    .select('id, status')
    .eq('case_id', caseId)
    .eq('group', '1')
    .eq('phase_order', 1)
    .maybeSingle();
  if (error) {
    console.error('getSubmissionPhaseId', error);
    return null;
  }
  return data?.id || null;
}

/**
 * Same Supabase + notifications as PhasesTimelineTab `handleSubmitCase` (no toast confirm — caller may wrap).
 */
export async function runDentistCaseSubmission({
  caseId,
  caseNumber,
  phaseId,
  requirePackage = false,
}) {
  if (!caseId) throw new Error('caseId requis');
  const pid = phaseId || (await getSubmissionPhaseId(caseId));
  if (!pid) throw new Error('Phase de soumission introuvable');

  await assertCaseReadyForDentistSubmission(caseId, { requirePackage });

  const now = new Date().toISOString();
  await supabase
    .from('case_timeline_phases')
    .update({ status: 'submitted', end_date: now, progress_percentage: 100, updated_at: now })
    .eq('id', pid);
  await supabase
    .from('case_timeline_phases')
    .update({ status: 'in_progress', start_date: now, updated_at: now })
    .eq('case_id', caseId)
    .eq('group', '1')
    .eq('phase_order', 2);
  await supabase.from('cases').update({ status: 'submitted', updated_at: now }).eq('id', caseId);

  const { data: authData } = await supabase.auth.getUser();
  const submitterId = authData?.user?.id || null;

  await notificationService.notifyAllAdministrators({
    type: 'info',
    title: 'Conception soumise',
    message: `Le cas ${caseNumber || caseId} a été soumis et est en attente de révision`,
    link: `/case-detail/${caseId}`,
    metadata: { caseId, caseNumber },
    excludeUserIds: submitterId ? [submitterId] : [],
  });
}

/**
 * UI helper: confirm then submit.
 */
export function confirmAndSubmitDentistCaseConception({ caseId, caseNumber, phaseId, onSuccess }) {
  toast('Êtes-vous sûr de vouloir soumettre cette conception ?', {
    className: 'forceVT',
    action: {
      label: 'Confirmer',
      onClick: async () => {
        try {
          await runDentistCaseSubmission({ caseId, caseNumber, phaseId });
          toast.success('Conception soumise avec succès !');
          if (onSuccess) onSuccess();
        } catch (err) {
          toast.error('Erreur lors de la soumission : ' + (err?.message || err));
        }
      },
    },
    cancel: { label: 'Annuler', onClick: () => {} },
    duration: 10000,
  });
}
